<!-- eslint-disable -->
<template>
       <v-form >
              <v-form >  <br>
                             <h4 :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" class="text-xs-center subheading font-weight-light pt-0 mt-0 ml-5">
                                <b> PLEASE NOTE</b>: {{configData.message}}
                               </h4>              
                            <v-form style="text-align:center;font-size:15px" v-if="this.$vuetify.breakpoint.name=='xs' && this.e1 == 1">
                            <h2 :style="{color:$store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" >
                               Organisation Application
                            </h2> 
                            </v-form>
                            <v-form style="text-align:center; font-size:25px" v-if="this.$vuetify.breakpoint.name!='xs' && this.e1 == 1">
                            <v-spacer></v-spacer>
                            <h2 :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">
                               Organisation Application
                            </h2> 
                            </v-form>
                            
   <v-container class="elevation-0" v-if="e1!=0" :class="{'width:90%': $vuetify.breakpoint.mdAndDown, 'largeStepWidth': $vuetify.breakpoint.xl  }">

     <v-stepper class="elevation-0"  :alt-labels="altlabel" v-model="e1">
      <v-stepper-header   class="elevation-0" :class="{'smallWidth': $vuetify.breakpoint.xs}" v-if="!this.$vuetify.breakpoint.xs" style="height:80px;" >
      
        <v-stepper-step :editable="editIfValidOne"  @click="stepOne()" v-if="this.e1>=1 && this.max>=1" style="font-size:12px;" :complete="e1 > 1" step="1"><span :style="{color:$store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Organisation Info</span></v-stepper-step>
        <v-stepper-step :editable="editIfValidOne"  @click="stepOne()" v-else style="font-size:12px;" :complete="e1 > 1" step="1">Organisation Info</v-stepper-step>

        <v-divider></v-divider>
  
        <v-stepper-step :editable="editIfValidTwo"  @click="stepTwo()" v-if="this.e1>=2 && this.max>=2" style="font-size:12px;" :complete="e1 > 2" step="2"><span :style="{color:$store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Documents & Links</span></v-stepper-step>
        <v-stepper-step  :editable="editIfValidTwo"  @click="stepTwo()" v-else-if="this.e1<=2 && this.max>=2" style="font-size:12px;" :complete="e1 > 2" step="2"><span :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Documents & Links</span></v-stepper-step>
        <v-stepper-step  v-else style="font-size:12px;" :complete="e1 > 2" step="2">Documents & Links</v-stepper-step>

        <v-divider></v-divider>
  
        <v-stepper-step  :editable="editIfValidThree" @click="stepThree()" v-if="this.e1>=3 && this.max>=3" style="font-size:12px;" :complete="e1 > 3" step="3"><span :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Contact Info</span></v-stepper-step>
        <v-stepper-step  :editable="editIfValidThree" @click="stepThree()" v-else-if="this.e1<=3 && this.max>=3" style="font-size:12px;" :complete="e1 > 3" step="3"><span :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Contact Info</span></v-stepper-step>
        <v-stepper-step   v-else style="font-size:12px;" :complete="e1 > 3" step="3">Contact Info</v-stepper-step>
 
       <v-divider></v-divider>

       <v-stepper-step  :editable="editIfValidFour" @click="stepFour()" v-if="this.e1>=4 && this.max>=4" style="font-size:12px;" :complete="e1 > 4" step="4"><span :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Address Info</span></v-stepper-step>
        <v-stepper-step  :editable="editIfValidFour" @click="stepFour()" v-else-if="this.e1<=4 && this.max>=4" style="font-size:12px;" :complete="e1 > 4" step="4"><span :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Address Info</span></v-stepper-step>
        <v-stepper-step   v-else style="font-size:12px;" :complete="e1 > 4" step="4">Address Info</v-stepper-step>
 
       <v-divider></v-divider>
  
        <v-stepper-step  :editable="editIfValidFive" @click="stepFive()" v-if="this.e1>=5 && this.max>=5" style="font-size:12px;" :complete="e1 > 5" step="5"><span :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Customer Support Info</span></v-stepper-step>
        <v-stepper-step  :editable="editIfValidFive" @click="stepFive()" v-else-if="this.e1<=5 && this.max>=5" style="font-size:12px;" :complete="e1 > 5" step="5"><span :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Customer Support Info</span></v-stepper-step>
        <v-stepper-step   v-else style="font-size:12px;" :complete="e1 > 5" step="5">Customer Support Info</v-stepper-step>
 
        </v-stepper-header>

        <v-stepper-header  v-if="this.$vuetify.breakpoint.xs"  >
        <v-stepper-step :editable="editIfValidOne"  v-if="this.e1>=1 && this.max>=1" @click="stepOne()" :complete="e1 > 1" step="1"></v-stepper-step>
        <v-stepper-step :editable="editIfValidOne"  @click="stepOne()" v-else :complete="e1 > 1" step="1"></v-stepper-step>
  
        <v-stepper-step :editable="editIfValidTwo" v-if="this.e1>=2 && this.max>=2" @click="stepTwo()" :complete="e1 > 2" step="2"></v-stepper-step>
        <v-stepper-step :editable="editIfValidTwo" v-else-if="this.e1<=2 && this.max>=2" @click="stepTwo()" :complete="e1 > 2" step="2"></v-stepper-step>
        <v-stepper-step v-else :complete="e1 > 2" step="2"></v-stepper-step>
  
        <v-stepper-step :editable="editIfValidThree" v-if="this.e1>=3 && this.max>=3" @click="stepThree()" :complete="e1 > 3" step="3"></v-stepper-step>
        <v-stepper-step :editable="editIfValidThree" @click="stepThree()" v-else-if="this.e1<=3 && this.max>=3" :complete="e1 > 3" step="3"></v-stepper-step>
        <v-stepper-step v-else :complete="e1 > 3" step="3"></v-stepper-step>

        <v-stepper-step :editable="editIfValidFour" v-if="this.e1>=4 && this.max>=4" @click="stepFour()" :complete="e1 > 4" step="4"></v-stepper-step>
        <v-stepper-step :editable="editIfValidFour" @click="stepFour()" v-else-if="this.e1<=4 && this.max>=4" :complete="e1 > 4" step="4"></v-stepper-step>
        <v-stepper-step v-else :complete="e1 > 4" step="4"></v-stepper-step>
  
        <v-stepper-step  :editable="editIfValidFive" @click="stepFive()" v-if="this.e1>=5 && this.max>=5" :complete="e1 > 5" step="5"></v-stepper-step>
        <v-stepper-step  :editable="editIfValidFive" @click="stepFive()" v-else-if="this.e1<=5 && this.max>=5" :complete="e1 > 5" step="5"></v-stepper-step>
        <v-stepper-step   v-else :complete="e1 > 5" step="5"></v-stepper-step>
 

        </v-stepper-header>
  
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card flat :class="{'smandDownStep': $vuetify.breakpoint.xsOnly , 'compact-form': $vuetify.breakpoint.smAndUp}" v-if="chooseOne" >
                     
 <v-card :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" flat color="white">     
   <h2 v-if="altlabel==false || this.$vuetify.breakpoint.name=='sm'" :style="{color:$store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" style="text-align:center">
     Organisation Info
    </h2> 
     <v-row>             
             <v-row row wrap>
                  <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                      <span class=" subheading mt-0 pt-0">*Registered Name:</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-text-field class="mt-0 pt-0" hide-details="auto" :rules="regNameRules" v-model="organisationDetail.registeredName"></v-text-field>
                  </v-col>
                     
                  <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                      <span class=" subheading">*Trading-As Name:</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" :rules="tradingNameRules" v-model="organisationDetail.name"></v-text-field>
                  </v-col>
                  </v-row>          
                                
                  <v-row row wrap>                  
                   <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                      <span class="subheading">Preferred VLAN:</span>
                  </v-col>
                 <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-autocomplete hide-details="auto" class=" mt-0 pt-0" clearable :items="vlans" v-model="organisationDetail.preferredVlan"></v-autocomplete>
                  </v-col>

               <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                   <span class="subheading">VAT Number:</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-text-field hide-details="auto"  class="mt-0 pt-0" v-model="organisationDetail.vatNo"></v-text-field>
                  </v-col> 
                </v-row>         
                                
                  <v-row row wrap>
                     <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                      <span class="subheading">Primary Colour:</span>
                  </v-col>
                 <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                        <chromepicker style="width:100%" v-model="organisationDetail.primaryColour" />
                  </v-col> 

                    <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                            <span class="subheading">Secondary Colour:</span>
                        </v-col>
                      <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                              <chromepicker  style="width:100%" v-model="organisationDetail.secondaryColour" />
                        </v-col> 
                  </v-row>                   
                </v-row>
              </v-card>                               
            <br>
                  <v-row width="100%" class="justify-end">
               
                         <v-btn style="ml-5" v-if="(this.organisationDetail.registeredName != null && this.organisationDetail.registeredName != '')
                         && (this.organisationDetail.name != null && this.organisationDetail.name != '')
                         && this.max==1" rounded @click=" max=2;
                        resize();e1=2; chooseOne=false; chooseTwo=true;" color="primary">{{ nextBtn }}<v-icon>chevron_right</v-icon></v-btn>
                        <v-btn style="ml-5" v-else-if="(this.organisationDetail.registeredName != null && this.organisationDetail.registeredName != '')
                         && (this.organisationDetail.name != null && this.organisationDetail.name != '')
                         && this.max!=1" rounded @click="
                        resize();e1=2; chooseOne=false; chooseTwo=true;" color="primary">{{ nextBtn }}<v-icon>chevron_right</v-icon></v-btn>
                       <v-btn style="ml-5" v-else disabled rounded color="primary">{{ nextBtn }}<v-icon>chevron_right</v-icon></v-btn> 
                 
               </v-row> 
            </v-card>                   
      </v-stepper-content>
  
      <v-stepper-content step="2">
         <v-card :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" :class="{'smandDownStep': $vuetify.breakpoint.xsOnly , 'compact-form': $vuetify.breakpoint.smAndUp}" flat v-if="chooseTwo" >
            <v-row>    

               <v-col  cols="12" sm="12" md="6" lg="6" xl="6">
                  <h2 v-if="altlabel==false || this.$vuetify.breakpoint.name=='sm'" :style="{color:$store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" style="text-align:center">
                 Documents  
             </h2> 
                  <v-row style="text-align:center" row wrap>
                   <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                        <v-file-input hide-details="auto"  v-model="logoModel" class="mt-0 pt-0" @change="selectFile($event, 'logo')" chips label="Upload Logo"></v-file-input>
                   </v-col>
                  </v-row>

                   <v-row style="text-align:center" v-if="organisationDetail.logo!==null" row wrap>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-img
                    :key="key"
                    :src="organisationDetail.logo"
                    max-height="70px"
                    contain
                    class="white"
                  ></v-img>
                  </v-col>
                  </v-row>
                 <v-row row wrap>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                     <v-file-input hide-details="auto" v-model="registration" class=" mt-0 pt-0" @change="selectFile($event, 'registrationDocument')" chips label="Company Registration Document"></v-file-input>
                  </v-col>
                  </v-row>  
                  <v-row row wrap>
                 <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                     <v-file-input hide-details="auto" v-model="icasa" class="mt-0 pt-0" @change="selectFile($event, 'icasaDocument')" chips label="Upload  ICASA Document"></v-file-input>
                  </v-col>
                  </v-row>  

                    <v-row row wrap>
                 <v-col cols="3" sm="3" md="3" lg="6" xl="6">
                      <span class="mt-0 pt-0">ICASA License Number:</span>
                  </v-col>
                <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" v-model="organisationDetail.icasaLicenseNumber"></v-text-field>
                  </v-col>
                     </v-row> 

                        
                 </v-col>                 
               <v-col cols="12" sm="12" md="6" lg="6" xl="6">
              <h2 v-if="altlabel==false || this.$vuetify.breakpoint.name=='sm'" :style="{color:$store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" style="text-align:center">
                 Links  
             </h2> 
                     <v-row row wrap>
                 <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                      <span class="subheading">*Website URL:</span>
                  </v-col>
                <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" :rules="webUrlRules" v-model="organisationDetail.websiteUrl"></v-text-field>
                  </v-col>
                     </v-row>
                  <v-row row wrap>
           <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                    <v-tooltip max-width="185px"  bottom>
                     <template v-slot:activator="{ on }">
                     <span v-on="on" class="subheading">FUP URL:</span> 
                      </template>
                      <span>Display in end customer application page</span>
                      </v-tooltip>
                  </v-col>
               <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" v-model="organisationDetail.fupUrl"></v-text-field>
                  </v-col>
                  </v-row>          
                                
                  <v-row row wrap>
                  <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                     <v-tooltip max-width="185px" bottom>
                     <template v-slot:activator="{ on }">
                   <span v-on="on" class="subheading">*T's & C's Link:</span> 
                  </template>
                     <span>Display in end customer application page</span>
                   </v-tooltip>
                  </v-col>
               <v-col cols="6" sm="6" md="6" lg="6" xl="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" :rules="tcLinkRules" v-model="organisationDetail.termsAndConditionsLink"></v-text-field>
                  </v-col>
                  </v-row>                   
               </v-col>
              
              
                </v-row>
                               
              <v-row v-if="this.$vuetify.breakpoint.xs">
                            <v-col >
                            <v-row class="justify-left">
                            <v-col >
                            <v-btn style="pl-0;" medium rounded @click="resize(); e1=1; chooseTwo=false; chooseOne=true" color="primary"><v-icon>chevron_left</v-icon>{{previousBtn}}</v-btn>
                            </v-col>
                            </v-row> 
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col >
                            <v-row class="justify-end">
                            <v-spacer></v-spacer>
                            <v-col >
                              <v-btn medium v-if="
                            (this.organisationDetail.websiteUrl != null && this.organisationDetail.websiteUrl != '' )
                            && (this.organisationDetail.termsAndConditionsLink != null && this.organisationDetail.termsAndConditionsLink != '')
                            && this.validLink(this.organisationDetail.websiteUrl)&& this.validLink(this.organisationDetail.termsAndConditionsLink)
                            && this.max==2" rounded @click="max=3;resize(); e1 = 3;chooseTwo=false; chooseThree=true" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn medium v-else-if="            
                             (this.organisationDetail.websiteUrl != null && this.organisationDetail.websiteUrl != '' )
                            && (this.organisationDetail.termsAndConditionsLink != null && this.organisationDetail.termsAndConditionsLink != '')
                            && this.validLink(this.organisationDetail.websiteUrl)&& this.validLink(this.organisationDetail.termsAndConditionsLink)
                             && this.max!=2" rounded @click="resize(); e1 = 3;chooseTwo=false; chooseThree=true" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn v-else medium rounded disabled color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            </v-col>
                            </v-row> 
                            </v-col>
                            </v-row>
                             
                         <v-row v-else>                           
                              <v-col>
                            <v-btn style="pl-0;" medium rounded @click="resize(); e1=1; chooseTwo=false; chooseOne=true" color="primary"><v-icon>chevron_left</v-icon>{{previousBtn}}</v-btn>
                              </v-col>
                              <v-col class="text-right">
                             <v-btn  medium v-if="
                            (this.organisationDetail.websiteUrl != null && this.organisationDetail.websiteUrl != '' )
                            && (this.organisationDetail.termsAndConditionsLink != null && this.organisationDetail.termsAndConditionsLink != '')
                            && this.validLink(this.organisationDetail.websiteUrl)&& this.validLink(this.organisationDetail.termsAndConditionsLink)
                            && this.max==2" rounded @click="max=3;resize(); e1 = 3;chooseTwo=false; chooseThree=true" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn  medium v-else-if="            
                             (this.organisationDetail.websiteUrl != null && this.organisationDetail.websiteUrl != '' )
                            && (this.organisationDetail.termsAndConditionsLink != null && this.organisationDetail.termsAndConditionsLink != '')
                            && this.validLink(this.organisationDetail.websiteUrl)&& this.validLink(this.organisationDetail.termsAndConditionsLink)
                             && this.max!=2" rounded @click="resize(); e1 = 3;chooseTwo=false; chooseThree=true" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn  v-else medium rounded disabled color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            </v-col>
                         </v-row>
                     
      </v-card>       
     </v-stepper-content>
  
     <v-stepper-content step="3">
       <v-card :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" :class="{'smandDownStep': $vuetify.breakpoint.xsOnly , 'compact-form': $vuetify.breakpoint.smAndUp}" flat v-if="chooseThree" >
        
              <h2 style="text-align:center" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Personal Contact Details <v-tooltip  max-width="200px" bottom>
                     <template v-slot:activator="{ on }">
                   <span v-on="on" medium ><v-icon color="primary" class="mb-1">info</v-icon></span> 
                  </template>
                     <span>Person with initial admin rights that will manage users</span>
                   </v-tooltip></h2>
             <v-row>             
                 <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                      <span class="subheading">*Title:</span>
                  </v-col>
                      <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-select hide-details="auto" :items="titles" :rules="titleRules" class="mt-0 pt-0" v-model="organisationDetail.primaryContactTitle"></v-select>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                      <span class="subheading">*First Name:</span>
                  </v-col>
                     <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-text-field hide-details="auto" :rules="firstNameRules" class="mt-0 pt-0" v-model="organisationDetail.primaryContactFirstname"></v-text-field>
                  </v-col>
                 <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <span class="subheading">*Last Name:</span>
                  </v-col>
               <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-text-field  hide-details="auto" :rules="lastNameRules" class="mt-0 pt-0" v-model="organisationDetail.primaryContactLastname"></v-text-field>
                  </v-col>
                    <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                      <span class="subheading">*Mobile Number:</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-text-field hide-details="auto" :rules="contactNumberRules" class="mt-0 pt-0" v-model="organisationDetail.primaryContactMobileNumber"></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                      <span class="subheading">*Email Address:</span>
                  </v-col>
                      <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-text-field hide-details="auto" :rules="emailRules" class="mt-0 pt-0" v-model="organisationDetail.primaryContactEmailAddress"></v-text-field>
                  </v-col>
                   <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                  <span class="subheading">*ID Number:</span>
                   </v-col>
                     <v-col cols="6" sm="6" md="6" lg="3" xl="3">
                       <v-text-field hide-details="auto" :rules="idNumberRules" class="mt-0 pt-0" v-model="organisationDetail.primaryContactIdNumber"></v-text-field>
                  </v-col>
                </v-row>             
                        
               
             
                      <v-row v-if="this.$vuetify.breakpoint.xs">
                            <v-col >
                            <v-row class="justify-left">
                            <v-col >
                            <v-btn style="pl-0;" medium rounded @click="resize(); e1=2; chooseThree=false; chooseTwo=true" color="primary"><v-icon>chevron_left</v-icon>{{previousBtn}}</v-btn>
                            </v-col>
                            </v-row> 
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col >
                            <v-row class="justify-center">
                              <v-spacer></v-spacer>
                            <v-col >
                              <v-btn  medium v-if="
                               (this.organisationDetail.primaryContactFirstname!=null && this.organisationDetail.primaryContactFirstname!='') && (this.organisationDetail.primaryContactLastname != null && this.organisationDetail.primaryContactLastname != '')
                                && (this.organisationDetail.primaryContactMobileNumber != null && this.organisationDetail.primaryContactMobileNumber != '' && this.organisationDetail.primaryContactMobileNumber.length >= 10)  
                                && (this.organisationDetail.primaryContactIdNumber != null && this.organisationDetail.primaryContactIdNumber != '' && this.organisationDetail.primaryContactIdNumber.length >= 9) 
                                && (this.organisationDetail.primaryContactTitle != null && this.organisationDetail.primaryContactTitle != '')
                                && (this.organisationDetail.primaryContactEmailAddress != null && this.organisationDetail.primaryContactEmailAddress != '') && this.validEmail(this.organisationDetail.primaryContactEmailAddress)

                                && this.max==3" rounded @click="max=4;resize(); e1 = 4;chooseThree=false; chooseFour=true" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn  medium v-else-if="
                               (this.organisationDetail.primaryContactFirstname!=null && this.organisationDetail.primaryContactFirstname!='') && (this.organisationDetail.primaryContactLastname != null && this.organisationDetail.primaryContactLastname != '')
                                && (this.organisationDetail.primaryContactMobileNumber != null && this.organisationDetail.primaryContactMobileNumber != '' && this.organisationDetail.primaryContactMobileNumber.length >= 10)  
                                && (this.organisationDetail.primaryContactIdNumber != null && this.organisationDetail.primaryContactIdNumber != '' && this.organisationDetail.primaryContactIdNumber.length >= 9) 
                                && (this.organisationDetail.primaryContactTitle != null && this.organisationDetail.primaryContactTitle != '')
                                && (this.organisationDetail.primaryContactEmailAddress != null && this.organisationDetail.primaryContactEmailAddress != '') && this.validEmail(this.organisationDetail.primaryContactEmailAddress)
                               && this.max!=3" rounded @click="resize(); e1 = 4;chooseThree=false; chooseFour=true" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn  v-else medium rounded disabled color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                             </v-col>
                            </v-row> 
                            </v-col>
                            </v-row>
                             
                            <v-row v-else>                           
                              <v-col>
                            <v-btn style="pl-0;" medium rounded @click="resize(); e1=2; chooseThree=false; chooseTwo=true" color="primary"><v-icon>chevron_left</v-icon>{{previousBtn}}</v-btn>
                              </v-col>
                              <v-col class="text-right">
                            <v-btn  medium v-if="
                            (this.organisationDetail.primaryContactFirstname!=null && this.organisationDetail.primaryContactFirstname!='') && (this.organisationDetail.primaryContactLastname != null && this.organisationDetail.primaryContactLastname != '')
                                && (this.organisationDetail.primaryContactMobileNumber != null && this.organisationDetail.primaryContactMobileNumber != '' && this.organisationDetail.primaryContactMobileNumber.length >= 10)  
                                && (this.organisationDetail.primaryContactIdNumber != null && this.organisationDetail.primaryContactIdNumber != '' && this.organisationDetail.primaryContactIdNumber.length >= 9) 
                                && (this.organisationDetail.primaryContactTitle != null && this.organisationDetail.primaryContactTitle != '')
                                && (this.organisationDetail.primaryContactEmailAddress != null && this.organisationDetail.primaryContactEmailAddress != '') && this.validEmail(this.organisationDetail.primaryContactEmailAddress)
                                && this.max==3" rounded @click="max=4;resize(); e1 = 4;chooseThree=false; chooseFour=true" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn  medium v-else-if="
                                 (this.organisationDetail.primaryContactFirstname!=null && this.organisationDetail.primaryContactFirstname!='') && (this.organisationDetail.primaryContactLastname != null && this.organisationDetail.primaryContactLastname != '')
                                && (this.organisationDetail.primaryContactMobileNumber != null && this.organisationDetail.primaryContactMobileNumber != '' && this.organisationDetail.primaryContactMobileNumber.length >= 10)  
                                && (this.organisationDetail.primaryContactIdNumber != null && this.organisationDetail.primaryContactIdNumber != '' && this.organisationDetail.primaryContactIdNumber.length >= 9) 
                                && (this.organisationDetail.primaryContactTitle != null && this.organisationDetail.primaryContactTitle != '')
                                && (this.organisationDetail.primaryContactEmailAddress != null && this.organisationDetail.primaryContactEmailAddress != '') && this.validEmail(this.organisationDetail.primaryContactEmailAddress)
                                && this.max!=3" rounded @click="resize(); e1 = 4;chooseThree=false; chooseFour=true" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn  v-else medium rounded disabled color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                           </v-col>
                        
                         </v-row>                     
                   
          </v-card>
      </v-stepper-content>

 <v-stepper-content step="4">
                <v-card  :class="{'smandDownStep': $vuetify.breakpoint.xsOnly , 'compact-form': $vuetify.breakpoint.smAndUp}" flat v-if="chooseFour" >      

        <v-card  :style="{color:$store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" flat color="white"> 
          <h2 style="text-align:center" :style="{color:$store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Physical Address</h2>
          <v-container :class="{'widthStep': $vuetify.breakpoint.mdAndUp}" >
                  <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span class="subheading">Unit No. & Building Name:</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" v-model="organisationDetail.physicalAddressLine1"></v-text-field>
                  </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span class="subheading">*Street No. & Name:</span>
                  </v-col>
                 <v-col cols="6" sm="6" md="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" :rules="physicalAddressLine2Rules" v-model="organisationDetail.physicalAddressLine2"></v-text-field>
                  </v-col>    
                   </v-row>
                   <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span class="subheading">*City:</span>
                  </v-col>
                   <v-col cols="6" sm="6" md="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" :rules="physicalAddressLine3Rules" v-model="organisationDetail.physicalAddressLine3"></v-text-field>
                  </v-col>   
                      </v-row>
                     <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span class="subheading">*Zip Code:</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" :rules="physicalAddressLine4Rules" v-model="organisationDetail.physicalAddressLine4"></v-text-field>
                  </v-col>   
                   </v-row>
                     <v-row>
                    <v-col cols="6" sm="6" md="6">
                      <span class="subheading">*Province:</span>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                       <v-text-field hide-details="auto" class="mt-0 pt-0" :rules="physicalAddressLine5Rules" v-model="organisationDetail.physicalAddressLine5"></v-text-field>
                  </v-col>   
                   </v-row>
              </v-container>            
                <v-row v-if="this.$vuetify.breakpoint.xs">
                             <v-col>
                            <v-row class="justify-left">
                             <v-col>
                            <v-btn style=" pl-0 ml-0;" medium rounded @click="resize(); e1=3; chooseFour=false; chooseThree=true" color="primary"><v-icon>chevron_left</v-icon>{{previousBtn}}</v-btn>
                            </v-col>
                            </v-row> 
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col >
                            <v-row class="justify-center">
                             <v-spacer></v-spacer>  
                             <v-col >
                              <v-btn medium v-if=" (this.organisationDetail.physicalAddressLine2!=null && this.organisationDetail.physicalAddressLine2!='')
                                && (this.organisationDetail.physicalAddressLine3!=null && this.organisationDetail.physicalAddressLine3!='')
                                && (this.organisationDetail.physicalAddressLine4!=null && this.organisationDetail.physicalAddressLine4!='')                                
                                && (this.organisationDetail.physicalAddressLine5!=null && this.organisationDetail.physicalAddressLine5!='') 
                            && this.max==4" rounded @click="max=5;resize();e1 = 5; chooseFour=false; chooseFive=true;" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn medium v-else-if="(this.organisationDetail.physicalAddressLine2!=null && this.organisationDetail.physicalAddressLine2!='')
                                && (this.organisationDetail.physicalAddressLine3!=null && this.organisationDetail.physicalAddressLine3!='')
                                && (this.organisationDetail.physicalAddressLine4!=null && this.organisationDetail.physicalAddressLine4!='') 
                               && (this.organisationDetail.physicalAddressLine5!=null && this.organisationDetail.physicalAddressLine5!='') 
                             && this.max!=4" rounded @click="resize(); e1 = 5; chooseFour=false; chooseFive=true;" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn v-else medium rounded disabled color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                           </v-col>
                            </v-row> 
                            </v-col>
                            </v-row>
                            <v-row v-else>                         
                             
                            <v-btn style=" margin-top:10px; pl-0 ml-0;" medium rounded @click="resize(); e1=3; chooseFour=false; chooseThree=true" color="primary"><v-icon>chevron_left</v-icon>{{previousBtn}}</v-btn>
                             
                              <v-spacer></v-spacer>
                              <v-col class="text-right">
                           <v-btn  medium v-if="(this.organisationDetail.physicalAddressLine2!=null && this.organisationDetail.physicalAddressLine2!='')
                                && (this.organisationDetail.physicalAddressLine3!=null && this.organisationDetail.physicalAddressLine3!='')
                                && (this.organisationDetail.physicalAddressLine4!=null && this.organisationDetail.physicalAddressLine4!='')                                
                                && (this.organisationDetail.physicalAddressLine5!=null && this.organisationDetail.physicalAddressLine5!='') 
                            && this.max==4" rounded @click="max=5;resize();e1 = 5; chooseFour=false; chooseFive=true;" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn  medium v-else-if=" (this.organisationDetail.physicalAddressLine2!=null && this.organisationDetail.physicalAddressLine2!='')
                                && (this.organisationDetail.physicalAddressLine3!=null && this.organisationDetail.physicalAddressLine3!='')
                                && (this.organisationDetail.physicalAddressLine4!=null && this.organisationDetail.physicalAddressLine4!='') 
                                && (this.organisationDetail.physicalAddressLine5!=null && this.organisationDetail.physicalAddressLine5!='') 
                             && this.max!=4" rounded @click="resize(); e1 = 5; chooseFour=false; chooseFive=true;" color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                            <v-btn  v-else medium rounded disabled color="primary">{{nextBtn}}<v-icon>chevron_right</v-icon></v-btn>
                           </v-col>
                         </v-row>        
                </v-card>
          </v-card>
      </v-stepper-content>
       <v-stepper-content step="5">
                <v-card  :class="{'smandDownStep': $vuetify.breakpoint.xsOnly , 'compact-form': $vuetify.breakpoint.smAndUp}" flat v-if="chooseFive" >
        <v-container style="text-align:center">
            <h2 :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Customer Support Info</h2>
      </v-container>           

        <v-card :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" flat color="white">    
                   
        <v-simple-table
        :fixed-header="false"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">Support Method</th>
              <th  class="text-center">Contact</th>
              <th  class="text-center">Hours of Availability</th>
              <th class="text-center">Description</th>
            </tr>
          </thead>
          <tbody >
             <tr style="text-align:center"> 
               <td style="text-align:center">*Email</td>
             <td style="text-align:center"><v-text-field :rules="customerSupportEmailRules" v-model="organisationDetail.customerSupportEmail"></v-text-field></td>
             <td  style="text-align:center"><v-select :rules="customerSupportEmailDescriptionRules" :items="['24 hrs', 'Business Hours', 'Other']"  v-model="organisationDetail.customerSupportEmailDescription"></v-select></td>
             <td v-if="organisationDetail.customerSupportEmailDescription=='Other'" style="text-align:center"><v-textarea :rules="customerSupportEmailOtherRules"  outline auto-grow  v-model="customerSupportEmailOther"></v-textarea></td>
             <td v-if="organisationDetail.customerSupportEmailDescription=='24 hrs'" style="text-align:center"><span >Available at all hours</span></td>
             <td v-if="organisationDetail.customerSupportEmailDescription=='Business Hours'" style="text-align:center"><span >Monday - Friday, 08:00 to 17:00</span></td>
             </tr>

             <tr style="text-align:center">
             <td style="text-align:center">*Telephone</td>
             <td style="text-align:center"><v-text-field :rules="customerSupportTelephoneRules" v-model="organisationDetail.customerSupportTelephone"></v-text-field></td>
             <td  style="text-align:center"><v-select :rules="customerSupportTelephoneDescriptionRules" :items="['24 hrs', 'Business Hours', 'Other']"  v-model="organisationDetail.customerSupportTelephoneDescription"></v-select></td>
             <td v-if="organisationDetail.customerSupportTelephoneDescription=='Other'" style="text-align:center"><v-textarea :rules="customerSupportTelephoneOtherRules" outline auto-grow v-model="customerSupportTelephoneOther"></v-textarea></td>
             <td v-if="organisationDetail.customerSupportTelephoneDescription=='24 hrs'" style="text-align:center"><span >Available at all hours</span></td>
             <td v-if="organisationDetail.customerSupportTelephoneDescription=='Business Hours'" style="text-align:center"><span  >Monday - Friday, 08:00 to 17:00</span></td>            
             </tr>
            
             <tr class="text-xs-center"> 
               <td style="text-align:center" >Whatsapp</td>
             <td style="text-align:center"><v-text-field  v-model="organisationDetail.customerSupportWhatsapp"></v-text-field></td>
             <td  style="text-align:center"><v-select :items="['24 hrs', 'Business Hours', 'Other']"  v-model="organisationDetail.customerSupportWhatsappDescription"></v-select></td>
             <td v-if="organisationDetail.customerSupportWhatsappDescription=='Other'" style="text-align:center"><v-textarea :rules="customerSupportWhatsappOtherRules" outline auto-grow v-model="customerSupportWhatsappOther"></v-textarea></td>
             <td v-if="organisationDetail.customerSupportWhatsappDescription=='24 hrs'" style="text-align:center"><span >Available at all hours</span></td>
             <td v-if="organisationDetail.customerSupportWhatsappDescription=='Business Hours'" style="text-align:center"><span  >Monday - Friday, 08:00 to 17:00</span></td>    
             </tr>
          </tbody>
        </template>
      </v-simple-table>

                         <v-row v-if="this.$vuetify.breakpoint.xs">
                            <v-col >
                            <v-row class="justify-left">
                            <v-col >
                            <v-btn style="pl-0;" medium rounded @click="resize(); e1=4; chooseFive=false; chooseFour=true" color="primary"><v-icon>chevron_left</v-icon>{{previousBtn}}</v-btn>
                            </v-col>
                            </v-row> 
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col >
                            <v-row class="justify-center">
                              <v-spacer></v-spacer>
                            <v-col >
                             <v-btn medium v-if="submitValidation()==true
                            && this.max==5" rounded @click="max=5;resize(); e1 = 0;chooseFive=false; complete=true;submit()" color="primary">SUBMIT<v-icon>chevron_right</v-icon></v-btn>
                          
                            <v-btn  medium v-else-if="submitValidation()==true
                            && this.max!=5" rounded @click="resize(); e1 = 0;chooseFive=false; complete=true;submit()" color="primary">SUBMIT<v-icon>chevron_right</v-icon></v-btn>
                            
                            <v-btn  v-else medium rounded disabled color="primary">SUBMIT<v-icon>chevron_right</v-icon></v-btn>
                           </v-col>
                            </v-row> 
                            </v-col>
                            </v-row>
                             
                           <v-row v-else>                         
                        <v-btn style="pl-0;margin-left:20px;margin-top:10px;" medium rounded @click="resize(); e1=4; chooseFive=false; chooseFour=true" color="primary"><v-icon>chevron_left</v-icon>{{previousBtn}}</v-btn>
                         <v-spacer></v-spacer>
                              <v-col class="text-right">
                         <v-btn style=" margin-left:45px" medium v-if="submitValidation()==true
                            && this.max==5" rounded @click="max=5;resize(); e1 = 0;chooseFive=false; complete=true;submit()" color="primary">SUBMIT<v-icon>chevron_right</v-icon></v-btn>
                          
                            <v-btn style=" margin-left:45px" medium v-else-if="submitValidation()==true
                            && this.max!=5" rounded @click="resize(); e1 = 0;chooseFive=false; complete=true;submit()" color="primary">SUBMIT<v-icon>chevron_right</v-icon></v-btn>
                            
                            <v-btn style=" margin-left:45px" v-else medium rounded disabled color="primary">SUBMIT<v-icon>chevron_right</v-icon></v-btn>
                            </v-col>
                         </v-row>   

                    </v-card>
          </v-card>
      </v-stepper-content>
     </v-stepper-items>
    </v-stepper>
     
    </v-container>
        
         <!-- Complete modal -->
                         <v-card flat v-if="complete">                        
                          <v-container style="text-align:center;" >     
                               <v-icon size="150"  color="primary">mdi-checkbox-marked-circle</v-icon>
                            </v-container>
                            <v-container style="text-align:center;">
                               <h2 :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Submission Successful</h2>
                               <h3 :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}">Thank you for submitting your details.</h3>
                              </v-container>
                           <v-container style="text-align:center;">
                                      <v-btn  medium color="primary"
                                        rounded @click=" clearFields(); max=1; e1=1; chooseOne=true; complete=false " >                                       
                                        OK
                                      </v-btn>
                             </v-container>
                            </v-card>

     </v-form>
    </v-form>  
</template>

<script>
import Api from "@/services/Api";
import { Chrome } from 'vue-color'

export default {
  components: {
    'chromepicker': Chrome
  },
  data() {
    return {
                nextBtn:'NEXT',
                previousBtn:'PREVIOUS',
                colWidth:6,
                width:4,
                max:1,
                editIfValidOne:false,
                editIfValidTwo:false,
                editIfValidThree:false,
                editIfValidFour:false,
                editIfValidFive:false,
                altlabel:true,
                about:null,
                val:false,
                e1:1,
                chooseOne:true,
                chooseTwo:false,
                chooseThree:false,
                chooseFour:false,
                chooseFive:false,
                key:0,
                logo: '',
                organisationDetail: {primaryColour: this.$store.state.currentOrg.orderPrimaryColour,
                                    secondaryColour: this.$store.state.currentOrg.orderSecondaryColour,
                                    logo: null},
                file:'',
                complete:false,
                info:true,
                vlans:[],
                titles: ["Mr", "Mrs", "Miss", "Dr", "Prof", "Sir", "Madam", "Other"],
                titleRules:[
                  v => !!v || 'Title is required',
                ],
                regNameRules: [
                  v => !!v || 'Registered Name is required'
                ],
                tradingNameRules: [
                  v => !!v || 'Trading-As Name is required'
                ],
                customerSupportEmailRules: [
                  v => !!v || 'E-mail is required',
                      v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
                ],
                emailRules: [
                  v => !!v || 'Contact E-mail is required',
                      v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Contact E-mail must be valid',
                ],
                webUrlRules:[
                  v => !!v || 'Website URL is required',
                  v => /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(v) || 'Website URL must be valid'
                ], 
                tcLinkRules:[
                  v => !!v || "T's & C's link is required",
                    v => /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(v) || "T's & C's link must be valid"
                ],
                icasaRules:[
                  v => !!v || 'ICASA Document is required',
                ], 
                registrationRules:[
                  v => !!v || 'Company Registration Document is required',
                ], 
                vlanRules:[
                  v => !!v || "Preferred VLAN is required",
                ],
                firstNameRules: [
                  v => !!v || 'Contact First Name is required'
                ],
                lastNameRules: [
                  v => !!v || 'Contact Last Name is required'
                ],
                contactNumberRules: [
                  v => !!v || 'Contact Number is required',
                  v => v && v.length > 9 || 'Contact Number should be 10 digits'
                ],
                customerSupportTelephoneRules: [
                  v => !!v || 'Telephone Number is required',
                  v => v && v.length > 9 || 'Telephone Number should be 10 digits'
                ],
                idNumberRules: [
                  v => !!v || 'Contact ID Number is required',
                  v => v && v.length > 8 || 'Contact ID Number must be valid'
                ],

                physicalAddressLine2Rules: [
                  v => !!v || 'Street Name is required'
                ],
                physicalAddressLine3Rules: [
                  v => !!v || 'City is required'
                ],
                physicalAddressLine4Rules: [
                  v => !!v || 'Zip Code is required'
                ],
                physicalAddressLine5Rules: [
                  v => !!v || 'Province is required'
                ],
                customerSupportEmailDescriptionRules: [
                  v => !!v || 'Customer Support Email Availability is required'
                ],
                customerSupportTelephoneDescriptionRules: [
                  v => !!v || 'Customer Support Telephone Availability is required'
                ],
                customerSupportEmailOtherRules: [
                  v => !!v || 'Email Availability Description is required'
                ],
                customerSupportTelephoneOtherRules: [
                  v => !!v || 'Telephone Availability Description is required'
                ],
                customerSupportWhatsappOtherRules: [
                  v => !!v || 'Whatsapp Availability Description is required'
                ],
                icasa: null,
                logoModel: null,
                registration: null,           
                customerSupportWhatsappOther: null,
                customerSupportEmailOther:null,
                customerSupportTelephoneOther: null
                };
  },
  created() {
    this.initialize()
  },
   watch: {
           
            '$vuetify.breakpoint.xs': {
                    immediate: true,
                     handler(value) {
                         if(value){
                         this.altlabel=false
                         this.colWidth=12
                         this.width=12,
                         this.nextBtn=''
                         this.previousBtn=''
                         }
            }
         },
           '$vuetify.breakpoint.sm': {
                    immediate: true,
                     handler(value) {
                         if(value){ 
                         this.altlabel=true
                         this.colWidth=12
                         this.width=12,
                         this.nextBtn='NEXT'
                         this.previousBtn='PREVIOUS'
                         }
            }
         },
          '$vuetify.breakpoint.md': {
                    immediate: true,
                     handler(value) {
                         if(value){
                         this.altlabel=true
                         this.colWidth=6,
                         this.width=4,
                         this.nextBtn='NEXT'
                         this.previousBtn='PREVIOUS'
                         }
              }
         },
   },
  methods: {
    submitValidation(){            
    
                    if((this.organisationDetail.registeredName != null && this.organisationDetail.registeredName != '')
                    && (this.organisationDetail.name != null && this.organisationDetail.name != '')
                    && (this.organisationDetail.websiteUrl != null && this.organisationDetail.websiteUrl != '' )
                    && (this.organisationDetail.termsAndConditionsLink != null && this.organisationDetail.termsAndConditionsLink != '')
                    && this.validLink(this.organisationDetail.websiteUrl)&& this.validLink(this.organisationDetail.termsAndConditionsLink)

                    && (this.organisationDetail.primaryContactFirstname!=null && this.organisationDetail.primaryContactFirstname!='') && (this.organisationDetail.primaryContactLastname != null && this.organisationDetail.primaryContactLastname != '')
                    && (this.organisationDetail.primaryContactMobileNumber != null && this.organisationDetail.primaryContactMobileNumber != '' && this.organisationDetail.primaryContactMobileNumber.length >= 10)  
                    && (this.organisationDetail.primaryContactIdNumber != null && this.organisationDetail.primaryContactIdNumber != '' && this.organisationDetail.primaryContactIdNumber.length >= 9) 
                    && (this.organisationDetail.primaryContactTitle != null && this.organisationDetail.primaryContactTitle != '')
                    && (this.organisationDetail.primaryContactEmailAddress != null && this.organisationDetail.primaryContactEmailAddress != '') && this.validEmail(this.organisationDetail.primaryContactEmailAddress)
                   
                    && (this.organisationDetail.physicalAddressLine2!=null && this.organisationDetail.physicalAddressLine2!='')
                    && (this.organisationDetail.physicalAddressLine3!=null && this.organisationDetail.physicalAddressLine3!='')
                    && (this.organisationDetail.physicalAddressLine4!=null && this.organisationDetail.physicalAddressLine4!='')      
                    
                    && (this.organisationDetail.customerSupportEmail != null && this.organisationDetail.customerSupportEmail != '') && this.validEmail(this.organisationDetail.customerSupportEmail)
                    && (this.organisationDetail.customerSupportTelephone !=null && this.organisationDetail.customerSupportTelephone !='')&& this.organisationDetail.customerSupportTelephone.length >= 10 
                    && (this.organisationDetail.customerSupportEmailDescription !=null&& this.organisationDetail.customerSupportEmailDescription !='')
                    && (this.organisationDetail.customerSupportTelephoneDescription !=null&& this.organisationDetail.customerSupportTelephoneDescription !='')
                    && (this.organisationDetail.physicalAddressLine5!=null && this.organisationDetail.physicalAddressLine5!='') 
                    )                   
                   {
                     let proceed = true
                       if(this.organisationDetail.customerSupportEmailDescription=='Other'&&this.customerSupportEmailOther==null){
        proceed=false
      }
      if(this.organisationDetail.customerSupportTelephoneDescription=='Other'&&this.customerSupportTelephoneOther==null){
       proceed=false
      }
        if(this.organisationDetail.customerSupportWhatsappDescription=='Other'&&this.customerSupportWhatsappOther==null){
       proceed=false
      }
                     return proceed
                                      
                              }
        },
           stepOne(){               
               this.chooseOne=true,
               this.e1=1       
                if(this.max>=1)               
                 { this.editIfValidOne=true
                 }else{this.editIfValidOne=false}                   
            },
            stepTwo(){
                  if(this.max<2){
                   this.max=2
               }
               this.chooseTwo=true,
               this.e1=2            
                 if(this.max>=2)               
                 { this.editIfValidTwo=true
                 }else{
                 this.editIfValidTwo=false}
            },
            stepThree(){
                 if(this.max<3){
                   this.max=3
               }                
               this.chooseThree=true,
               this.e1=3                
                if(this.max>=3)
                { this.editIfValidThree=true}
                 else{
                 this.editIfValidThree=false}
            },     
            stepFour(){
                 if(this.max<4){
                   this.max=4
               }                
               this.chooseFour=true,
               this.e1=4                
                if(this.max>=4)
                { this.editIfValidFour=true}
                 else{
                 this.editIfValidFour=false}
            }, 
              stepFive(){
                 if(this.max<5){
                   this.max=5
               }                
               this.chooseFive=true,
               this.e1=5                
                if(this.max>=5)
                { this.editIfValidFive=true}
                 else{
                 this.editIfValidFive=false}
            },              
            resize(){
                window.scrollTo(0, 0); 
            },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validLink(link) {
      var re = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
      return re.test(link);    
    },
    generateVlans(){
      for(let i=1; i<4097; i++){
        this.vlans.push(i)
      }
    },
    clearFields(){     
      this.organisationDetail={}
      this.organisationDetail.logo=null,
      this.organisationDetail.primaryColour = this.$store.state.currentOrg.orderPrimaryColour,
      this.organisationDetail.secondaryColour= this.$store.state.currentOrg.orderSecondaryColour 
      this.logoModel = null,
      this.icasa = null,
      this.registration = null
      this.customerSupportWhatsappOther= null,
      this.customerSupportEmailOther= null,
      this.customerSupportTelephoneOther= null
      this.editIfValidOne=false,
      this.editIfValidTwo=false,
      this.editIfValidThree=false,
      this.editIfValidFour=false,
      this.chooseOne=true,
      this.chooseTwo=false,
      this.chooseThree=false,
      this.chooseFour=false
       this.complete=false
    },
    async selectFile(event, type) {
    this.file = event
    await this.uploadFile(this.file, type)
    },
    async uploadFile(file, type){
     var reader = await new FileReader();
     await reader.readAsDataURL(file);
     reader.onload = () => {     
     this.setResult(reader.result, type)
      }
     reader.onerror = function() {
        console.log('there are some problems');
    };
    },
    setResult(result, type){
      if(type=='logo'){
      this.organisationDetail.logo=result
      this.key+=1
      }else if(type=='icasaDocument'){
      this.organisationDetail.icasaDocument=result
      this.key+=1
      }else if(type=='registrationDocument'){
      this.organisationDetail.companyRegistrationDocument=result
      this.key+=1
      }       
    },
    submit() {
      let primaryColourChosen = null
      let secondaryColourChosen = null
       if(typeof(this.organisationDetail.primaryColour.hex)!=='undefined'){
        primaryColourChosen = this.organisationDetail.primaryColour.hex
      }else{
        primaryColourChosen = this.organisationDetail.primaryColour
      }
       if(typeof(this.organisationDetail.secondaryColour.hex)!=='undefined'){
        secondaryColourChosen = this.organisationDetail.secondaryColour.hex
      }else{
        secondaryColourChosen = this.organisationDetail.secondaryColour
      }
      if(this.organisationDetail.customerSupportEmailDescription=='Other'){
        this.organisationDetail.customerSupportEmailDescription=this.customerSupportEmailOther
      }
      if(this.organisationDetail.customerSupportTelephoneDescription=='Other'){
        this.organisationDetail.customerSupportTelephoneDescription=this.customerSupportTelephoneOther
      }
        if(this.organisationDetail.customerSupportWhatsappDescription=='Other'){
        this.organisationDetail.customerSupportWhatsappDescription=this.customerSupportWhatsappOther
      }
      Api().post("/organisationApplications", {
        name: this.organisationDetail.name,
        logo: this.organisationDetail.logo,
        primaryColour: primaryColourChosen,
        secondaryColour: secondaryColourChosen,
        vatNo: this.organisationDetail.vatNo,
        termsAndConditionsLink: this.organisationDetail.termsAndConditionsLink,
        websiteUrl: this.organisationDetail.websiteUrl,
        fupUrl: this.organisationDetail.fupUrl,
        preferredVlan: this.organisationDetail.preferredVlan,
        icasaDocument: this.organisationDetail.icasaDocument,
        primaryContactFirstname: this.organisationDetail.primaryContactFirstname,
        primaryContactLastname: this.organisationDetail.primaryContactLastname,
        primaryContactTitle: this.organisationDetail.primaryContactTitle,
        primaryContactMobileNumber: this.organisationDetail.primaryContactMobileNumber,
        primaryContactIdNumber: this.organisationDetail.primaryContactIdNumber,
        primaryContactEmailAddress: this.organisationDetail.primaryContactEmailAddress,
        physicalAddressLine1: this.organisationDetail.physicalAddressLine1,
        physicalAddressLine2: this.organisationDetail.physicalAddressLine2,
        physicalAddressLine3: this.organisationDetail.physicalAddressLine3,
        physicalAddressLine4: this.organisationDetail.physicalAddressLine4,
        companyRegistrationDocument: this.organisationDetail.companyRegistrationDocument,
        registeredName: this.organisationDetail.registeredName,
        customerSupportEmail: this.organisationDetail.customerSupportEmail,
        customerSupportTelephone: this.organisationDetail.customerSupportTelephone,
        customerSupportWhatsapp: this.organisationDetail.customerSupportWhatsapp,
        customerSupportEmailDescription: this.organisationDetail.customerSupportEmailDescription,
        customerSupportTelephoneDescription: this.organisationDetail.customerSupportTelephoneDescription,
        customerSupportWhatsappDescription: this.organisationDetail.customerSupportWhatsappDescription,
        icasaLicenseNumber: this.organisationDetail.icasaLicenseNumber,
        physicalAddressLine5: this.organisationDetail.physicalAddressLine5
      }).then(response=>{
            this.complete=true,
            this.info=false
      })
    },
    initialize() {
      this.generateVlans()
    }
  }
};
</script>
<style >
.largeStepWidth{
  width:80%;
}
.widthStep{
width: 50%;
}
 .smandDownStep{
   padding-left: 20px;
   width: 95%;
   font-size: 14px;
 }
   .compact-form {
    transform: scale(0.9);
    transform-origin: top;
}
</style>
